import script from "./remap-dropdown-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./remap-dropdown-search.vue?vue&type=script&setup=true&lang=ts"

import "./remap-dropdown-search.vue?vue&type=style&index=0&id=a939cbaa&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a939cbaa"]])

export default __exports__